export const FEES = {
  UM_REAL: {
    driver: 'ITAU',
    method: 'PIX',
    feeValue: 0,
    feeType: 'VALUE',
    transactionFeeValue: 1,
    transactionFeeType: 'VALUE',
  },
  NOVENTA_CENTAVOS: {
    driver: 'ITAU',
    method: 'PIX',
    feeValue: 0,
    feeType: 'VALUE',
    transactionFeeValue: 0.9,
    transactionFeeType: 'VALUE',
  },
  SESSENTA_CENTAVOS: {
    driver: 'ITAU',
    method: 'PIX',
    feeValue: 0,
    feeType: 'VALUE',
    transactionFeeValue: 0.6,
    transactionFeeType: 'VALUE',
  },
  VINTE_CENTAVOS: {
    driver: 'ITAU',
    method: 'PIX',
    feeValue: 1.67,
    feeType: 'PERCENTAGE',
    transactionFeeValue: 0.2,
    transactionFeeType: 'VALUE',
  },
  DOIS_REAIS_E_DEZ: {
    driver: 'ITAU',
    method: 'PIX',
    feeValue: 0,
    feeType: 'VALUE',
    transactionFeeValue: 2.1,
    transactionFeeType: 'PERCENTAGE',
  },
  DOIS_REAIS: {
    driver: 'ITAU',
    method: 'PIX',
    feeValue: 0,
    feeType: 'VALUE',
    transactionFeeValue: 2,
    transactionFeeType: 'VALUE',
  },
  UM_REAL_E_CINQUENTA: {
    driver: 'ITAU',
    method: 'PIX',
    feeValue: 0,
    feeType: 'VALUE',
    transactionFeeValue: 1.5,
    transactionFeeType: 'VALUE',
  },
  UM_E_CINQUENTA: {
    driver: 'ITAU',
    method: 'PIX',
    feeValue: 0,
    feeType: 'VALUE',
    transactionFeeValue: 1.5,
    transactionFeeType: 'PERCENTAGE',
  },
  // plan 9 do node-api: 2% percentage, sem taxa fixa por transação.
  DOIS_PCT: {
    driver: 'ITAU',
    method: 'PIX',
    feeValue: 2.0,
    feeType: 'PERCENTAGE',
    transactionFeeValue: 0,
    transactionFeeType: 'VALUE',
  },
} as const;

export type FEES = (typeof FEES)[keyof typeof FEES];

export type FeeKind = 'porcentagem' | 'fixo';

export interface MarketplaceFeeItem {
  driver: string;
  method: string;
  feeValue: number;
  feeType: string;
  transactionFeeValue: number;
  transactionFeeType: string;
}

export interface IMarketplacePayment {
  customerId: number;
  idi: number;
  marketplaceFees: MarketplaceFeeItem[];
  marketplaceFeesOld?: MarketplaceFeeItem[];
}
